// BL598 Phase 1A — `gridctl pickup <entity-name-or-id> [target-dir]`.
//
// `pickup` is the canonical takeover verb in the 3-verb collaboration model.
// It is functionally identical to the former `clone`: download the
// last-deployed source, write the entity's `cloudgrid.yaml`, and link the
// folder to the live entity (`.cloudgrid/link.json`) so the next
// `gridctl plug` deploys against the right entity. Both verbs share the same
// implementation via `makeCloneLikeCommand`; `clone` remains for one release
// with a deprecation notice. Server-side public-pickup semantics are deferred
// to BL600.

import { Command as CommanderCommand } from 'commander';
import { makeCloneLikeCommand } from './clone.js';

export const pickupCommand: CommanderCommand = makeCloneLikeCommand('pickup');
